import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'

// Первая минута в мире: короткая карточка «как играть». Показывается один раз
// на устройство (флаг в localStorage), пока игрок не нажмёт «ПОНЯТНО» или ESC.
// Дальше мир объясняет себя сам: контекстная карточка, палитра команд, ИИ-жители.

const STORAGE_KEY = 'testcs.welcome.v1'

const isTouchDevice = () =>
  typeof window !== 'undefined' && (('ontouchstart' in window) || Number(navigator?.maxTouchPoints) > 0)

export function WelcomeGuide({ world }) {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    try {
      if (localStorage.getItem(STORAGE_KEY)) return
    } catch (err) {
      return
    }
    setVisible(true)
  }, [])

  useEffect(() => {
    if (!visible) return
    const onKey = event => {
      if (event.code === 'Escape' || event.code === 'Enter') dismiss()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [visible])

  const dismiss = () => {
    try {
      localStorage.setItem(STORAGE_KEY, '1')
    } catch (err) {
      // приватный режим — просто не запоминаем
    }
    setVisible(false)
  }

  if (!visible) return null
  const touch = isTouchDevice()

  // Текст сверен с миром 06.08. Раньше карточка звала на «остров ORIGIN»,
  // снесённый 04.08: новичок шёл туда, где ничего нет. Называем то, что есть.
  const rows = [
    ['🕹', touch ? 'Стик слева — ходьба, свайп — камера' : 'WASD — ходьба · мышь — камера · Shift — бег'],
    ['🎭', 'Кнопка ПЕРСОНАЖ внизу — выбери, кем быть (сохранится)'],
    ['🌀', 'Три светящиеся арки вокруг маяка — порталы в ТОРГОВЫЙ КРУГ, ТИХУЮ РОЩУ и на ПОЛИГОН'],
    ['💬', 'ЧАТ и ЛЮДИ — общение; Mia и Зодчий живут здесь же, заговори с ними'],
    ['🏗', 'КВАРТАЛ УЧАСТКОВ — через карту: там своя земля и стройка (кнопка СОЗДАТЬ)'],
  ]

  return (
    <div
      css={css`
        position: absolute;
        inset: 0;
        z-index: 60;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(7, 2, 17, 0.55);
        backdrop-filter: blur(6px);
        .welcome-card {
          width: min(92vw, 30rem);
          border-radius: 1.1rem;
          border: 1px solid rgba(255, 45, 149, 0.45);
          background: linear-gradient(160deg, rgba(26, 11, 58, 0.96), rgba(11, 5, 23, 0.96));
          box-shadow: 0 0 2.4rem rgba(255, 45, 149, 0.25), 0 0 5rem rgba(0, 229, 255, 0.12);
          padding: 1.4rem 1.5rem 1.2rem;
          color: #f4ecff;
        }
        .welcome-title {
          font-size: 1.05rem;
          font-weight: 750;
          letter-spacing: 0.14em;
          color: #ff6ec7;
          margin-bottom: 0.2rem;
        }
        .welcome-sub {
          font-size: 0.78rem;
          opacity: 0.75;
          margin-bottom: 1rem;
        }
        .welcome-row {
          display: flex;
          gap: 0.7rem;
          align-items: flex-start;
          margin-bottom: 0.65rem;
          font-size: 0.86rem;
          line-height: 1.35;
        }
        .welcome-row span:first-of-type {
          flex-shrink: 0;
          filter: drop-shadow(0 0 6px rgba(0, 229, 255, 0.6));
        }
        .welcome-btn {
          margin-top: 0.9rem;
          width: 100%;
          min-height: 44px;
          border: none;
          border-radius: 0.7rem;
          background: linear-gradient(90deg, #ff2d95, #7b2d8b);
          color: white;
          font-size: 0.95rem;
          font-weight: 700;
          letter-spacing: 0.12em;
          cursor: pointer;
        }
        .welcome-btn:hover {
          filter: brightness(1.15);
        }
      `}
    >
      <div className='welcome-card' role='dialog' aria-label='Как играть'>
        <div className='welcome-title'>ДОБРО ПОЖАЛОВАТЬ В TESTCS</div>
        <div className='welcome-sub'>Живой мир-чат: гуляй, общайся, стройся. Вот всё, что нужно знать:</div>
        {rows.map(([icon, text]) => (
          <div className='welcome-row' key={text}>
            <span>{icon}</span>
            <span>{text}</span>
          </div>
        ))}
        <button type='button' className='welcome-btn' onClick={dismiss}>
          ПОНЯТНО, ИДУ ГУЛЯТЬ
        </button>
      </div>
    </div>
  )
}
